import React from "react";
import { UGCVideoCreationModal } from "../../../../features/ugc-video/components/UGCVideoCreationModal";

type UGCVideoRightPanelProps = React.ComponentProps<typeof UGCVideoCreationModal>;

export const UGCVideoRightPanel: React.FC<UGCVideoRightPanelProps> = (props) => {
  return <UGCVideoCreationModal {...props} />;
};
